module.exports = __webpack_public_path__ + "img/undraw_time_management_30iu.c2bf412d.svg";